const tiposCafe = {
  PERGAMIN_SECO: 1,
  CEREZO_ARABIGO: 2,
  CEREZO_UVA: 3,
  CEREZO_ROBUSTA: 4,
  PERGAMINO_HUMEDO: 5,
  OREADO: 6,
  PRESECADO: 7,
  OTRO: 8,
  CACAO_LAVADO: 9,
  CACAO_FERMENTADO: 10,
  PIMIENTA_GORDA_SECADO: 11,
};

export { tiposCafe };
